const features = [
  {
    icon: 'ri-seedling-line',
    title: 'Pregnancy Weekly Tracking',
    description: "Follow your baby's development week by week from size comparisons to body changes, symptoms, and important milestones.",
    badge: 'Core',
    badgeColor: 'teal',
    image: 'https://public.readdy.ai/ai/img_res/81f07bc24d88ca818f9f9f629039965b.jpg'
  },
  {
    icon: 'ri-hospital-line',
    title: 'Hospital Recommendations',
    description: "Smart recommendations across 21+ Pune hospitals government & private with cost breakdowns, NICU availability, and location maps.",
    badge: 'Core',
    badgeColor: 'teal',
    image: 'https://readdy.ai/api/search-image?query=large%20modern%20hospital%20building%20exterior%20with%20clear%20signage%20bright%20daylight%20well%20maintained%20white%20and%20gray%20facade%20wide%20entrance%20medical%20facility%20with%20ambulance%20bay%20lush%20green%20surroundings%20professional%20real%20world%20photography%20sharp%20vivid%20colors%20Indian%20urban%20setting%20clean%20wide%20angle%20shot%20no%20blur%20no%20text%20overlay&width=600&height=400&seq=feature-hospital-v9&orientation=landscape'
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Health Insights & Guidance',
    description: 'Data-driven insights on maternal health, nutrition, and care sourced from government health guidelines and real hospital data.',
    badge: 'Insights',
    badgeColor: 'sky',
    image: 'https://readdy.ai/api/search-image?query=health-data-analytics-dashboard-screen-showing-maternal-health-charts-graphs-insights-medical-statistics-clean-modern-ui-teal-blue-color-theme-professional-healthcare-technology-platform-white-background&width=600&height=400&seq=feature-insights-v2&orientation=landscape'
  },
  {
    icon: 'ri-road-map-line',
    title: 'Care Journey Timeline',
    description: 'Your complete pregnancy-to-baby timeline. Know exactly what to do at every stage checkups, tests, vaccinations, and more.',
    badge: 'Timeline',
    badgeColor: 'rose',
    image: 'https://readdy.ai/api/search-image?query=timeline-roadmap-visualization-of-pregnancy-journey-to-baby-care-milestones-illustrated-clean-infographic-style-soft-pink-teal-color-palette-white-background-modern-healthcare-journey-map-professional-flat-illustration&width=600&height=400&seq=feature-timeline-v2&orientation=landscape'
  }
];

const badgeColors: Record<string, string> = {
  teal: 'bg-teal-50 text-teal-700 border-teal-100',
  sky: 'bg-sky-50 text-sky-700 border-sky-100',
  rose: 'bg-rose-50 text-rose-700 border-rose-100'
};

const iconColors: Record<string, string> = {
  teal: 'bg-teal-50 text-teal-600',
  sky: 'bg-sky-50 text-sky-600',
  rose: 'bg-rose-50 text-rose-600'
};

export default function Features() {
  return (
    <section id="features" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 border border-teal-100 rounded-full mb-5">
            <i className="ri-star-line text-teal-600"></i>
            <span className="text-sm font-semibold text-teal-700">Core Features</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-5 leading-tight">
            What You <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-sky-500">Get</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Everything you need to navigate pregnancy and baby care all in one beautifully simple platform.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group border border-gray-100 rounded-2xl overflow-hidden hover:-translate-y-1 hover:border-teal-100 transition-all"
            >
              <div className="relative h-64 sm:h-72 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className={`absolute top-4 left-4 border text-xs font-bold px-3 py-1 rounded-full ${badgeColors[feature.badgeColor]}`}>
                  {feature.badge}
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${iconColors[feature.badgeColor]}`}>
                    <i className={`${feature.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">{feature.title}</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
